import React, { useMemo, memo } from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';

interface IProps {
  operations: Operation[],
  operationsSelected: string[]
}

const S3Plugin = React.lazy(() => importFromS3('variable-rate'));
const MFPlugin = React.lazy(() => import('variableRate/VariableRate'));

export const VariableRatePluginContainer: React.FC<IProps> = memo(({ operations, operationsSelected }: IProps) => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.variableRate.module-federation'];

  const VariableRatePlugin = useModuleFederation ? MFPlugin : S3Plugin;

  const { isLoading, operation: impersonatedOperation } = useImpersonatedOperation();
  const selectedOperations = useMemo(() => impersonatedOperation 
    ? [impersonatedOperation.operationId] 
    : operationsSelected, 
  [impersonatedOperation, operationsSelected]);

  if (isLoading || !selectedOperations.length) return null;

  return (
    <VariableRatePlugin
      operations={operations}
      operationsSelected={selectedOperations}
    />
  );
}, (prevProps, nextProps) => prevProps.operationsSelected === nextProps.operationsSelected);